import { Component, Inject, OnInit } from '@angular/core';
import { GraphUser } from '../models/graph-user.model';
import { FormControl } from '@angular/forms';
import { DataService } from '../services/data.service';
import _ from "lodash";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-assignment-dashboard-dialog',
  templateUrl: './assignment-dashboard-dialog.component.html',
  styleUrls: ['./assignment-dashboard-dialog.component.scss']
})
export class AssignmentDashboardDialogComponent implements OnInit {

  onYes = new EventEmitter();
  
  formOwner: GraphUser;
  formOwnerControl = new FormControl();
  formOwnerOptions: GraphUser[];

  currentAssignment: GraphUser;
  currentAssignmentControl = new FormControl();
  currentAssignmentOptions: GraphUser[];

  constructor(private dataService: DataService, @Inject(MAT_DIALOG_DATA) public data: any, 
  public dialogRef: MatDialogRef<AssignmentDashboardDialogComponent>) { }

  ngOnInit() {
    this.currentAssignment = this.data.currentAssignment;
    if (!this.currentAssignment.mail) {
      this.currentAssignment = null;
    }
    this.formOwner = this.data.formOwner;
    if (!this.formOwner.mail) {
      this.formOwner = null;
    }
  }

  searchUsersFormOwner(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.formOwnerOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('formOwnerField')[0].focus();
      })
    });
  }

  deleteFormOwner() {
    this.formOwner = '' as any;
    this.formOwnerOptions = [];
  }

  displayFnFormOwner(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    }
    else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    }
    else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    }
    else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    }
    else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    }
    else {
      return value;
    }
  }

  searchUsersCurrentAssignment(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.currentAssignmentOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('currentAssignmentField')[0].focus();
      })
    });
  }

  deleteCurrentAssignment() {
    this.currentAssignment = '' as any;
    this.currentAssignmentOptions = [];
  }

  displayFnCurrentAssignment(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    }
    else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    }
    else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    }
    else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    }
    else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    }
    else {
      return value;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveAndClose() {
    let dataStructure = {
      currentAssignment: this.currentAssignment,
      formOwner: this.formOwner
    }
    this.onYes.emit(dataStructure);
    this.dialogRef.close();
  }

}
